<template>
    <v-container fluid class="password-reset-container">
        <v-row no-gutters justify="center">
            <v-col cols="5" class="password-reset-container__content">
                <v-row no-gutters justify="center">
                    <v-col cols="4" class="mb-10 ml-5">
                        <v-list-item
                            href="https://roadcube.com"
                            class="d-flex justify-center align-center rounded-lg "
                            style="max-width: 200px;"
                        >
                            <img
                                src="@/assets/home/logo-sticky.png"
                                width="160"
                                style="vertical-align: middle"
                        /></v-list-item>
                    </v-col>

                    <v-col cols="12">
                        <v-card
                            outlined
                            class="password-reset-container__card mb-6"
                        >
                            <v-row no-gutters>
                                <v-card
                                    flat
                                    class="pa-0 ma-0 w-100"
                                    style="width: 100%;"
                                    :disabled="timerCooldown > 0"
                                >
                                    <v-col cols="12">
                                        <v-card-title
                                            class="text-h6 font-weight-black pl-0"
                                        >
                                            {{
                                                translations.passwordReset[lang]
                                            }}
                                        </v-card-title>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-card-subtitle
                                            class="
                                            font-weight-bold
                                            black--text
                                            pl-0
                                            pt-6
                                        "
                                        >
                                            {{ translations.step1[lang] }}
                                        </v-card-subtitle>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            class="mobile-select"
                                            v-model="mobile"
                                            type="number"
                                            :label="translations.mobile[lang]"
                                            color="primary"
                                            outlined
                                            solo
                                            flat
                                            dense
                                            clearable
                                            :disabled="timerCooldown > 0"
                                            :success="success.mobile"
                                            :error-messages="error.mobile"
                                            @focus="error.mobile = ''"
                                            @blur="validateMobile"
                                        >
                                            <template v-slot:prepend-inner>
                                                <v-select
                                                    style="max-width: 120px;max-height: 38px;"
                                                    class="pt-0 ml-0 pl-0 countrySelect"
                                                    v-model="countryId"
                                                    item-value="country_id"
                                                    :items="activeCountries"
                                                    menu-props="offsetY"
                                                    :label="
                                                        translations.country[
                                                            lang
                                                        ]
                                                    "
                                                    solo
                                                    flat
                                                    dense
                                                    color="secondary"
                                                    item-color="secondary"
                                                    :disabled="
                                                        timerCooldown > 0
                                                    "
                                                    :success="success.country"
                                                    :error-messages="
                                                        error.country
                                                    "
                                                    @focus="error.country = ''"
                                                    @change="validateCountry"
                                                >
                                                    <template
                                                        v-slot:label
                                                        style="min-width:80px"
                                                    >
                                                        <span>{{
                                                            translations
                                                                .country[lang]
                                                        }}</span>
                                                    </template>
                                                    <template
                                                        v-slot:selection="{
                                                            item
                                                        }"
                                                    >
                                                        <v-row
                                                            no-gutters
                                                            class="d-flex align-center"
                                                        >
                                                            <v-col class="mr-0">
                                                                <img
                                                                    :src="
                                                                        item.flag
                                                                    "
                                                                    width="25"
                                                                    style="vertical-align: middle"
                                                                    class="mr-0"
                                                                />
                                                            </v-col>

                                                            <v-col
                                                                cols="auto"
                                                                >{{
                                                                    item.phone_code
                                                                }}</v-col
                                                            >
                                                        </v-row>
                                                    </template>
                                                    <template
                                                        v-slot:item="{ item }"
                                                    >
                                                        <v-row no-gutters>
                                                            <v-col class="mr-3">
                                                                <img
                                                                    :src="
                                                                        item.flag
                                                                    "
                                                                    width="25"
                                                                    style="vertical-align: middle"
                                                                    class="mr-3"
                                                                />
                                                                {{
                                                                    item.name
                                                                }}
                                                                ({{
                                                                    item.code
                                                                }})
                                                            </v-col>

                                                            <v-col
                                                                cols="auto"
                                                                >{{
                                                                    item.phone_code
                                                                }}</v-col
                                                            >
                                                        </v-row>
                                                    </template>
                                                </v-select>
                                            </template></v-text-field
                                        >
                                    </v-col>

                                    <v-col cols="12">
                                        <v-btn
                                            :loading="loading"
                                            class="card__btn"
                                            :disabled="timerCooldown > 0"
                                            @click="
                                                sendForgotPassword({
                                                    mobile: mobile,
                                                    country_id: countryId
                                                })
                                            "
                                        >
                                            {{ translations.sendSms[lang] }}
                                            <span
                                                v-if="timerCooldown > 10"
                                                class="px-1"
                                                >(00:{{ timerCooldown }})</span
                                            >
                                            <span
                                                v-else-if="timerCooldown > 0"
                                                class="px-1"
                                                >(00:0{{ timerCooldown }})</span
                                            >
                                        </v-btn>
                                    </v-col>
                                </v-card>
                                <v-card
                                    flat
                                    class="pa-0 ma-0 w-100"
                                    style="width: 100%;"
                                    :disabled="!step2Enabled"
                                >
                                    <v-col cols="12">
                                        <v-card-subtitle
                                            class="
                                            font-weight-bold
                                            black--text
                                            pl-0
                                            pt-6
                                            mt-6
                                        "
                                        >
                                            {{ translations.step2[lang] }}
                                        </v-card-subtitle>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-otp-input
                                            style="max-width: 200px;"
                                            v-model="verificationCode"
                                            type="number"
                                            length="4"
                                            autocomplete="one-time-code"
                                            :label="
                                                translations.verificationCode[
                                                    lang
                                                ]
                                            "
                                            color="primary"
                                            outlined
                                            solo
                                            flat
                                            dense
                                            clearable
                                        ></v-otp-input>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            v-model="password"
                                            :type="showPassword ? 'text' : 'password'"
                                            autocomplete="new-password"
                                            :label="translations.newPassword[lang]"
                                            color="primary"
                                            outlined
                                            solo
                                            flat
                                            dense
                                            clearable
                                            :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                                            @click:append="showPassword = !showPassword"
                                            :success="success.password_confirmation"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            v-model="passwordConfirmation"
                                            :type="showPasswordConfirmation ? 'text' : 'password'"
                                            autocomplete="new-password"
                                            :label="translations.confirmNew[lang]"
                                            color="primary"
                                            outlined
                                            solo
                                            flat
                                            dense
                                            clearable
                                            :append-icon="showPasswordConfirmation ? 'mdi-eye-off' : 'mdi-eye'"
                                            @click:append="showPasswordConfirmation = !showPasswordConfirmation"
                                            :success="success.password_confirmation"
                                            :error-messages="error.password_confirmation"
                                            @focus="error.password_confirmation = ''"
                                            @blur="validatePasswordConfirmation"
                                        ></v-text-field>
                                    </v-col>
                                </v-card>
                                <v-col cols="12" class="px-3">
                                    <v-card-actions class="px-0 card__add-text">
                                        <v-btn
                                            :loading="loading"
                                            class="card__btn"
                                            :disabled="!step2Enabled"
                                            @click="save()"
                                        >
                                            {{ translations.save[lang] }}
                                        </v-btn>
                                        <v-spacer></v-spacer>
                                        {{ translations.knowPassword[lang] }}
                                        <router-link
                                            :to="`/${lang}/sign-in`"
                                            class="blue--text mx-1"
                                            >{{
                                                translations.signIn[lang]
                                            }}</router-link
                                        >
                                        {{ translations.here[lang] }}.
                                    </v-card-actions>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mdiEye, mdiEyeOff } from "@mdi/js";
import axios from "axios";
import { mapActions, mapMutations, mapState } from "vuex";
import validators from "@/utils/validators/passwordReset";
import translations from "@/utils/translations/signIn";

export default {
    name: "PasswordRecovery",

    mixins: [validators, translations],

    data() {
        return {
            mobile: "",
            verificationCode: "",
            password: "",
            passwordConfirmation: "",
            countryId: null,
            timerCooldown: 0,
            cooldownInterval: null,
            step2Enabled: false,
            showPassword: false,
            showPasswordConfirmation: false
        };
    },

    computed: {
        ...mapState(["loading", "activeCountries"]),

        lang() {
            return this.$route.params.lang;
        },
        selectedCountry() {
            return (
                (this.activeCountries || []).find(
                    x => x.country_id == this.countryId
                ) || {}
            );
        }
    },

    methods: {
        
        ...mapActions( [
            "loadActiveCountries",
        ]),
        ...mapActions("passwordReset", [
            "sendVerificationSMS",
            "updatePassword"
        ]),

        save() {
            const body = {
                mobile: this.mobile,
                mobile_verification_code: this.verificationCode,
                password: this.password,
                password_confirmation: this.passwordConfirmation
            };

            this.updatePassword(body);
        },
        async sendForgotPassword(data) {
            if (this.timerCooldown > 0) return;
            let res = await this.sendVerificationSMS(data);
            if (!res.error) {
                this.startCooldown();
            }
        },

        startCooldown() {
            this.step2Enabled = true;
            this.timerCooldown = 30;
            this.cooldownInterval = setInterval(() => {
                if (this.timerCooldown > 0) {
                    this.timerCooldown--;
                } else {
                    clearInterval(this.cooldownInterval);
                    this.cooldownInterval = null;
                }
            }, 1000);
        }
    },

    mounted() {
        if (!this.activeCountries || this.activeCountries.length === 0) {
            this.loadActiveCountries();
        }
    }
    
};
</script>
<style lang="scss">
.v-select.countrySelect > .v-input__control > .v-input__slot {
    cursor: pointer;
    padding-left: 0 !important;
}
.countrySelect {
    min-width: 120px;
    background: white;
    border-right: 1px dotted grey;
    margin-right: 12px;
}
.password-reset-container {
    height: 100%;
    padding: 0;
    background-color: #f5f5fd;
    font-family: "Roboto", sans-serif;

    .password-reset-container__content {
        margin-top: 6%;

        .password-reset-container__card {
            padding: 20px 100px;
        }
    }

    .card__btn {
        background-color: #2255fe !important;
        color: #f5f5fd;
    }
    .mobile-select .v-text-field__details {
        text-align: right;
        padding-left: 100px;
    }
    .mobile-select .countrySelect .v-text-field__details {
        padding: 4px 0 !important;
    }
    .mobile-select .v-input__slot {
        // padding-left: 0 !important;
    }
}
.card__add-text {
    font-size: 12px;
    font-weight: bold;

    .card__links {
        text-decoration: underline;
        cursor: pointer;
    }
}
</style>
